import { render } from "./UserBubble.vue?vue&type=template&id=7adbc77c"
import script from "./UserBubble.vue?vue&type=script&lang=js"
export * from "./UserBubble.vue?vue&type=script&lang=js"

import "./UserBubble.vue?vue&type=style&index=0&id=7adbc77c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__